export const LEGAL_INSTRUMENT_TYPES = [
    { id: 1, label: 'Convênio' },
    { id: 2, label: 'Termo de Fomento' },
    { id: 3, label: 'Acordo de Cooperação' },
    { id: 4, label: 'Contrato' },
    { id: 5, label: 'Outro' },
];

export function getLegalInstrumentTypeLabel(id?: number): string {
    return LEGAL_INSTRUMENT_TYPES.find((t) => t.id === id)?.label || '-';
}
